import React from 'react';
import { TransitionGroup } from 'react-transition-group';
import {
  Button, Icon, Heading, MessageModal,
} from '@fieldnation/platform-components';

import classes from './SuccessModal.scss';
import { SUCCESS_MODAL } from '../utils';
import { SuccessModalProps } from '../types.d';

const SuccessModal = ({ onClose }: SuccessModalProps): React.ReactElement => (
  <TransitionGroup>
    {/* @ts-ignore */}
    <MessageModal
      isOpen
      header="Private Feedback"
      borderedHeader
      bottomDivider={false}
      onClose={onClose}
    >
      <div className={classes.container}>
        <div className={classes.iconWrapper}>
          <span className={classes.icon}>
            <Icon name="completeSolid" size={96} />
          </span>
        </div>
        <div className={classes.heading}>
          <Heading styleLevel="h3">
            {SUCCESS_MODAL.TITLE.PRIVATE}
          </Heading>
        </div>
        <div className={classes.content}>
          {SUCCESS_MODAL.CONTENT.PRIVATE}
        </div>
      </div>
      <div className={classes.buttonGroup}>
        <Button
          label="Done"
          type="primary"
          disableTitleCasing
          onClick={onClose}
          size="lg"
        />
      </div>
    </MessageModal>
  </TransitionGroup>
);

export default SuccessModal;
